import { getNodes } from './actions';

import { ActionType } from '../action-types';
import { GLOBAL_FETCH_SIGNAL } from './settings';
import _ from 'lodash';
import fetch from 'fetch-retry';
import { fetchUrl } from './settings';
import axios from 'axios';

export const dashboardData = (sysId) => (dispatch, getState) => {
	return Promise.all([dispatch(getNodes([sysId])), dispatch(getSystemFull(sysId)), dispatch(getSystemFiles(sysId))])
};

export const clearDashboardData = () => (dispatch) => {
	dispatch({ type: ActionType.CLEAR_DASHBOARD_DATA });
};

export const getSystemFull = (systemID) => (dispatch, getState) => {
	let token = localStorage.getItem('w4-token');

	return fetch(`${fetchUrl}/system/${systemID}`, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		retries: 3,
		retryDelay: 2000,
		retryOn: function (attempt, error, response) {
			// retry on any network error, or 4xx or 5xx status codes
			if (error !== null || response.status >= 400) {
				return true;
			}
			return response.data;
		},
	})
		.then((response) => response.json())
		.then((data) => {
			return dispatch({
				type: ActionType.GET_SYSTEM_FULL,
				systemData: data,
				systemID: systemID,
			});
		})
		.then(() => dispatch(getSystemMapImage(systemID)))
};

export const getSystemFullWithoutClearingPreviousData = (systemId) => (dispatch, getState) => {
	let token = localStorage.getItem('w4-token');

	return fetch(`${fetchUrl}/system/${systemId}`, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		retries: 30,
		retryDelay: 2000,
		retryOn: function (attempt, error, response) {
			// retry on any network error, or 4xx or 5xx status codes
			if (error !== null || response.status >= 400) {
				return true;
			}
			return response.data;
		},
	})
		.then((response) => response.json())
		.then((data) => {
			return dispatch({
				type: ActionType.GET_SYSTEM_FULL,
				systemData: data,
				systemID: systemId,
			});
		})
};

export const getSystemMap = (systemId) => (dispatch, getState) => {
	let token = localStorage.getItem('w4-token');

	if (systemId > 0) {
		return fetch(`${fetchUrl}/system/system-map/${systemId}`, {
			method: 'GET',
			headers: {
				Authorization: `Bearer ${token}`,
			},
			signal: GLOBAL_FETCH_SIGNAL,
			retries: 10,
			retryDelay: 5000,
			retryOn: function (attempt, error, response) {
				// retry on any network error, or 4xx or 5xx status codes
				if (error !== null || response.status >= 400) {
					return true;
				}
				return response.data;
			},
		})
			.then((response) => response.json())
			.then((data) => {
				if (!data) {
					data = _.filter(getState().dashboardData.systems, { ID: systemId })[0].MapData;
				}
				dispatch({
					type: ActionType.GET_SYSTEM_MAP,
					isMapLoading: false,
					systemID: systemId,
					systemMapData: data,
				});
			})
			.catch((err) => {
				dispatch({
					type: ActionType.GET_SYSTEM_MAP,
					isMapLoading: true,
					systemID: systemId,
					systemMapData: '',
				});
			});
	}
};

const formatDateForHeader = (dateStr) => {
	const date = new Date(dateStr);
	const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  
	const dayName = days[date.getUTCDay()];
	const day = String(date.getUTCDate()).padStart(2, '0');
	const month = months[date.getUTCMonth()];
	const year = date.getUTCFullYear();
	const hours = String(date.getUTCHours()).padStart(2, '0');
	const minutes = String(date.getUTCMinutes()).padStart(2, '0');
	const seconds = String(date.getUTCSeconds()).padStart(2, '0');
  
	return `${dayName}, ${day} ${month} ${year} ${hours}:${minutes}:${seconds} GMT`;
  };

export const getSystemMapImage = (systemId) => async (dispatch, getState) => {
  if (!systemId) return;

  const token = localStorage.getItem("w4-token");
  const mainMapDataUpdatedAt =
    getState()?.dashboard?.system?.mapDataUpdatedAt.Valid ? getState()?.dashboard?.system?.mapDataUpdatedAt.Time : new Date();
  const secondMapDataUpdatedAt =
    getState()?.dashboard?.system?.secondMapDataUpdatedAt.Valid ? getState()?.dashboard?.system?.secondMapDataUpdatedAt.Time : new Date();
  const thirdMapDataUpdatedAt =
    getState()?.dashboard?.system?.thirdMapDataUpdatedAt.Valid ? getState()?.dashboard?.system?.thirdMapDataUpdatedAt.Time : new Date();

  try {
    // główna mapa oddzielnie bez czekania na dwie kolejne
    const mainMapResponse = await fetch(
      `${fetchUrl}/system/system-map-image/${systemId}/main`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "If-Modified-Since": formatDateForHeader(mainMapDataUpdatedAt),
        },
      }
    );

    const mainData = await mainMapResponse.blob();
    const dimensions = await getImageDimensionsFromBlob(mainData);

    dispatch({
      type: ActionType.GET_SYSTEM_MAP,
      isMapLoading: false,
      systemID: systemId,
      systemMapDataBlob: URL.createObjectURL(mainData),
      mainMapWidth: dimensions.width,
      mainMapHeight: dimensions.height,
    });

    // dwie dodatkowe mapy
    (async () => {
      try {
        const [secondResp, thirdResp] = await Promise.all([
          fetch(`${fetchUrl}/system/system-map-image/${systemId}/second`, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "If-Modified-Since": formatDateForHeader(secondMapDataUpdatedAt),
            },
          }),
          fetch(`${fetchUrl}/system/system-map-image/${systemId}/third`, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "If-Modified-Since": formatDateForHeader(thirdMapDataUpdatedAt),
            },
          }),
        ]);

        const [secondData, thirdData] = await Promise.all([
          secondResp.blob(),
          thirdResp.blob(),
        ]);
        dispatch({
          type: ActionType.GET_ALT_MAPS,
          systemSecondMapDataBlob: secondData.size ? URL.createObjectURL(secondData) : null,
		  systemThirdMapDataBlob: thirdData.size ? URL.createObjectURL(thirdData) : null,
        });

      } catch (err) {
        console.error("Error loading alternate maps", err);
      }
    })();

  } catch (err) {
    console.error("Error loading main map", err);
    dispatch({
      type: ActionType.GET_SYSTEM_MAP,
      isMapLoading: true,
      systemID: systemId,
      systemMapDataBlob: "",
    });
  }
};

const getImageDimensionsFromBlob = (blob) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const objectUrl = URL.createObjectURL(blob);

    img.onload = () => {
      const dimensions = {
        width: img.width,
        height: img.height,
      };

      URL.revokeObjectURL(objectUrl);
      resolve(dimensions);
    };

    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("Cannot load image"));
    };

    img.src = objectUrl;
  });
};

const imageExists = (mapData, callback) => {
	var img = new Image();
	img.onload = function () {
		callback(true);
	};
	img.onerror = function () {
		callback(false);
	};
	img.src = mapData;
};

export const checkScreenSize = (mobileView) => (dispatch) => {
	if (window.innerWidth >= 800 && mobileView) {
		dispatch({ type: ActionType.SET_DESKTOP_VIEW, mobileView: false });
	}
	if (window.innerWidth < 800 && !mobileView) {
		dispatch({ type: ActionType.SET_MOBILE_VIEW, mobileView: true });
	}
};

export const confirmPushNotifications = (accountId) => (dispatch) => {
	dispatch({ type: ActionType.ACCEPT_PUSH_NOTIFICATIONS, payload: accountId });
};

export const rejectPushNotifications = (accountId) => (dispatch) => {
	dispatch({ type: ActionType.REJECT_PUSH_NOTIFICATIONS, payload: accountId });
};

export const showFilteredSystems = (filteredSystems) => (dispatch) => {
	dispatch({
		type: ActionType.SHOW_FILTERED_SYSTEMS,
		payload: filteredSystems,
	});
};

export const showFilteredSystemsNames = (filteredSystems) => (dispatch) => {
	dispatch({
		type: ActionType.SHOW_FILTERED_SYSTEMS_NAMES,
		payload: filteredSystems,
	});
};

export const showFilteredNodesNames = (filteredNodes: string[]) => (dispatch) => {
	dispatch({
		type: ActionType.SHOW_FILTERED_NODES_NAMES,
		payload: filteredNodes,
	});
};

export const showFilteredNodes = (filteredNodes: number[]) => (dispatch) => {
	dispatch({
		type: ActionType.SHOW_FILTERED_NODES,
		payload: filteredNodes,
	});
};

export const updateFilteredSystemsNames = (isUpdatedName) => (dispatch) => {
	dispatch({
		type: ActionType.UPDATE_PICKED_SYSTEM_NAME,
		payload: isUpdatedName,
	});
};

export const showFilteredSystemGroups = (filteredSystemGroups) => (dispatch) => {
	dispatch({
		type: ActionType.SHOW_FILTERED_SYSTEM_GROUPS,
		payload: filteredSystemGroups,
	});
};

export const showFilteredSystemGroupsNames = (filteredSystemGroups) => (dispatch) => {
	dispatch({
		type: ActionType.SHOW_FILTERED_SYSTEM_GROUPS_NAMES,
		payload: filteredSystemGroups,
	});
};
export const updateFilteredSystemGroupsNames = (isUpdatedName) => (dispatch) => {
	dispatch({
		type: ActionType.UPDATE_PICKED_SYSTEM_GROUP_NAME,
		payload: isUpdatedName,
	});
};
export const showSystemSearchBar = (isVisible: boolean) => (dispatch) => {
	dispatch({
		type: ActionType.SHOW_SYSTEM_SEARCH_BAR,
		payload: isVisible,
	});
};
export const showSystemGroupSearchBar = (isVisible: boolean) => (dispatch) => {
	dispatch({
		type: ActionType.SHOW_SYSTEM_GROUP_SEARCH_BAR,
		payload: isVisible,
	});
};
export const getSystemFiles = (systemId) => (dispatch) => {
	let token = localStorage.getItem('w4-token');

	if (systemId > 0) {
		return fetch(`${fetchUrl}/system/files/${systemId}`, {
			method: 'GET',
			headers: {
				Authorization: `Bearer ${token}`,
			},
			signal: GLOBAL_FETCH_SIGNAL,
			retries: 0,
			retryDelay: 3000,
			retryOn: function (attempt, error, response) {
				return response.data;
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch({
					type: ActionType.GET_SYSTEM_FILES,
					systemFiles: data,
					systemID: systemId,
				});
			})
			.catch((err) => {
				dispatch({
					type: ActionType.GET_SYSTEM_FILES,
					systemFiles: [],
					systemID: systemId,
				});
			});
	}
};

export const getSystemFile = (systemFileId, systemFileName) => (dispatch, getState) => {
	let token = localStorage.getItem('w4-token');
	if (systemFileId > 0) {
		return fetch(`${fetchUrl}/system/file/${systemFileId}`, {
			method: 'GET',
			headers: {
				Authorization: `Bearer ${token}`,
			}
		})
		.then((response) => response.blob())
		.then((blob) => {
			let url = window.URL.createObjectURL(blob);
			let a = document.createElement('a');
			let rightNow = new Date();
			let res = rightNow.toISOString();

			a.href = url;
			a.download = `${systemFileName}`;
			document.body.appendChild(a); 
			a.click();
			a.remove();
		})
		.catch((err) => {
			dispatch({ type: ActionType.EXPORT_STOP, payload: systemFileId });
			dispatch({ type: ActionType.FETCH_ERROR, error: err });
		})
		.finally(() => {
			dispatch({ type: ActionType.EXPORT_STOP, payload: systemFileId });
		});
}
};


export const uploadFile = (formData, systemID) => (dispatch) => {
	dispatch({ type: ActionType.RESET_UPLOAD_SYSTEM_FILE_STATUS });
	const token = localStorage.getItem('w4-token');
	const startProgress = 0;
	dispatch({ type: ActionType.UPDATE_FILE_UPLOAD_PROGRESS, payload: startProgress });

	axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

	const config = {
		onUploadProgress: (progress) => {
			const { loaded, total } = progress;
			const currentProgress = Math.round((loaded * 100) / total);
			dispatch({ type: ActionType.UPDATE_FILE_UPLOAD_PROGRESS, payload: currentProgress });
		},
	};
	return axios
		.post(process.env.REACT_APP_API_URL + '/system/system-file', formData, config)
		.then((response) => {
			dispatch({ type: ActionType.UPDATE_FILE_UPLOAD_PROGRESS, payload: 100 });
			dispatch({ type: ActionType.FILE_UPLOAD_SUCCESS, systemId: parseInt(formData.systemID), newFile: response.data  });
		})
		.then(() => dispatch(getFileAccounts(systemID)))
		.catch((err) => {
			dispatch({ type: ActionType.UPDATE_FILE_UPLOAD_PROGRESS, payload: 100 });
			dispatch({ type: ActionType.FILE_UPLOAD_FAILED });
			dispatch({ type: ActionType.FAILED_UPLOAD_SYSTEM_FILE });
			console.error('Upload ERROR', err);
		});
};

export const deleteSystemFile = (systemFileId) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	if (systemFileId > 0) {
		return fetch(`${fetchUrl}/system/file/${systemFileId}`, {
			method: 'DELETE',
			headers: {
				Authorization: `Bearer ${token}`,
			}
		})
		.then((response) => {
			if (response.status !== 200) {
				throw new Error('File was not deleted');
			}
			dispatch({ type: ActionType.FILE_DELETED, fileId: systemFileId });
		})
		.catch((err) => {
			dispatch({ type: ActionType.EXPORT_STOP, payload: systemFileId });
			dispatch({ type: ActionType.FETCH_ERROR, error: err });
		})
		.finally(() => {
			dispatch({ type: ActionType.EXPORT_STOP, payload: systemFileId });
		});
}
};

export const getFileAccounts = (systemId) => (dispatch) => {
	let token = localStorage.getItem('w4-token');

	if (systemId > 0) {
		return fetch(`${fetchUrl}/system/${systemId}/files-accounts`, {
			method: 'GET',
			headers: {
				Authorization: `Bearer ${token}`,
			},
			signal: GLOBAL_FETCH_SIGNAL,
			retries: 0,
			retryDelay: 3000,
			retryOn: function (attempt, error, response) {
				return response.data;
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch({
					type: ActionType.GET_SYSTEM_FILE_ACCOUNTS,
					filesAccounts: data,
					systemId: systemId,
				});
			})
			.catch((err) => {
				dispatch({
					type: ActionType.GET_SYSTEM_FILE_ACCOUNTS,
					filesAccounts: [],
					systemId: systemId,
				});
			});
	}
};

export const setFileAccounts = (fileId, changes, systemID) => (dispatch) => {
	let token = localStorage.getItem('w4-token');

	if (fileId > 0) {
		return fetch(`${fetchUrl}/system/file/${fileId}/accounts`, {
			method: 'POST',
			headers: {
				Authorization: `Bearer ${token}`,
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				changes: changes,
			}),
			signal: GLOBAL_FETCH_SIGNAL,
			retries: 0,
			retryDelay: 3000,
			retryOn: function (attempt, error, response) {
				return response.data;
			},
		})
			.then((response) => {
				if (response.status !== 200) {
					throw new Error('File account assignments settings failed');
				}
				dispatch({
					type: ActionType.SET_SYSTEM_FILE_ACCOUNTS,
					success: true,
					fileId: fileId,
				});
			})
			.then(() => dispatch(getFileAccounts(systemID)))
			.catch((err) => {
				dispatch({
					type: ActionType.SET_SYSTEM_FILE_ACCOUNTS,
					success: false,
					fileId: fileId,
				});
			});
	}
};

export const getVisibleSystemGroups = () => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/system-groups`, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
		},
	})
		.then((resp) => {
			if (!resp.ok && resp.status !== 302) {
				// throw new Error("FETCH ERROR", resp.status, err);
				throw new Error('FETCH ERROR');
			}
			return resp.json();
		})
		.then((data) => {
			if (!data) {
				data = [];
			}
			dispatch({
				type: ActionType.GET_SYSTEM_GROUPS,
				systemGroups: data,
			});
		})
		.catch((err) => {
			dispatch({
				type: ActionType.FETCH_ERROR,
				error: err,
			});
		});
};

export const getSystemGroups = () => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/system-groups-installer`, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
		},
	})
		.then((resp) => {
			if (!resp.ok && resp.status !== 302) {
				// throw new Error("FETCH ERROR", resp.status, err);
				throw new Error('FETCH ERROR');
			}
			return resp.json();
		})
		.then((data) => {
			if (!data) {
				data = [];
			}
			dispatch({
				type: ActionType.GET_SYSTEM_GROUPS_INSTALLER,
				systemGroups: data,
			});
		})
		.catch((err) => {
			dispatch({
				type: ActionType.FETCH_ERROR,
				error: err,
			});
		});
};

export const setRainstormMode = (systemID, rainstormModeOn, rainstormModeSeconds, w2ConfigurationUpdatedAt) => (dispatch) => {

	let token = localStorage.getItem('w4-token');
	let reason = null;

	return fetch(`${fetchUrl}/system/w2-controller-rainstorm-mode`, {
		method: 'PATCH',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({
			systemID: systemID,
			rainstormModeOn: rainstormModeOn,
			rainstormModeSeconds: rainstormModeSeconds,
			w2ConfigurationUpdatedAt: w2ConfigurationUpdatedAt
		}),
		signal: GLOBAL_FETCH_SIGNAL,
		retries: 0,
		retryDelay: 3000,
		retryOn: function (attempt, error, response) {
			return response?.data;
		},
	})
		.then(async (response) => {
			const data = await response.json();
			if (response.status !== 200) {
				reason = data?.reason;
				throw new Error('Setting rainstorm mode failed');
			}
			const newW2ConfigurationUpdatedAt = (new Date(parseInt(data.newUpdatedAt) * 1000)).toISOString();
			const newRainstormModeEnd = (new Date(parseInt(data.newRainstormModeEnd) * 1000)).toISOString().split('Z')[0];
			dispatch(setRainstormMode2(systemID, newRainstormModeEnd, newW2ConfigurationUpdatedAt));
		})
		.catch((err) => {
			dispatch({
				type: ActionType.SET_RAINSTORM_MODE,
				success: false,
				reason: reason,
				systemID: 0,
			});
		});
}

export const setRainstormMode2 = (systemID, rainstormModeEnd, w2ConfigurationUpdatedAt) => (dispatch) => {
	let token = localStorage.getItem('w4-token');

	return fetch(`${fetchUrl}/system/w2-rainstorm-mode`, {
		method: 'PATCH',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({
			systemID: systemID,
			rainstormModeEnd: rainstormModeEnd,
			w2ConfigurationUpdatedAt: w2ConfigurationUpdatedAt
		}),
		signal: GLOBAL_FETCH_SIGNAL,
		retries: 0,
		retryDelay: 3000,
		retryOn: function (attempt, error, response) {
			return response?.data;
		},
	})
		.then((response) => {
			if (response.status !== 200) {
				throw new Error('Setting rainstorm mode failed');
			}
			const rainstormModeEndUtc = new Date(rainstormModeEnd + 'Z');
			const nowTime = (new Date()).getTime();
			dispatch({
				type: ActionType.SET_RAINSTORM_MODE,
				success: true,
				modeOn: rainstormModeEndUtc.getTime() > nowTime,
				systemID: systemID,
				rainstormModeEnd: rainstormModeEndUtc.toISOString(),
				w2ConfigurationUpdatedAt: w2ConfigurationUpdatedAt
			});
		})
		.catch((err) => {
			dispatch({
				type: ActionType.SET_RAINSTORM_MODE,
				success: false,
				systemID: 0,
			});
		});
}

export const sendTestNotification = (systemID, severity, systemVersion) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/test-log`, {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({
			systemID: systemID,
			severity: severity,
			systemVersion: systemVersion
		}),
		signal: GLOBAL_FETCH_SIGNAL,
		})
		.then((resp) => {
			if (!resp.ok && resp.status !== 302) {
				dispatch({
				type: ActionType.SEND_TEST_NOTIFICATION,
				success: false,
			});
			} else {
				dispatch({
					type: ActionType.SEND_TEST_NOTIFICATION,
					success: true,
				});
			}
			return resp.json();
		})
		.catch(() => {
			dispatch({
				type: ActionType.SEND_TEST_NOTIFICATION,
				success: false,
			});
		});
}

export const setServiceMode = (systemID, serviceModeOn, durationHours = 6) => (dispatch) => {

	let token = localStorage.getItem('w4-token');
	let reason = null;

	return fetch(`${fetchUrl}/system/service-mode`, {
		method: 'PATCH',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({
			systemID: systemID,
			serviceModeOn: serviceModeOn,
			durationHours: durationHours
		}),
		signal: GLOBAL_FETCH_SIGNAL,
		retries: 0,
		retryDelay: 3000,
		retryOn: function (attempt, error, response) {
			return response?.data;
		},
	})
	.then((resp) => {
		if (!resp.ok && resp.status !== 302) {
			// throw new Error("FETCH ERROR", resp.status, err);
			throw new Error('FETCH ERROR');
		}
		return resp.json();
	})
	.then((data) => {
		const nowTime = (new Date()).getTime();
		const serviceModeEndTime = (new Date(data.updatedAt)).getTime();
		dispatch({
			type: ActionType.SET_SERVICE_MODE,
			success: true,
			modeOn: serviceModeEndTime > nowTime,
			systemID: systemID,
			serviceModeEnd: data.updatedAt,
		});
	})
	.catch((err) => {
		dispatch({
			type: ActionType.SET_SERVICE_MODE,
			success: false,
			reason: reason,
			systemID: 0,
		});
	});
}

export const setSystemNotifications = (systemID, notificationsEmailOn, notificationsPushOn, notificationsSmsOn, updatedViaWebsiteAt) => (dispatch) => {
	let token = localStorage.getItem('w4-token');

	return fetch(`${fetchUrl}/system/notifications`, {
		method: 'PATCH',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({
			systemID,
			notificationsEmailOn, 
			notificationsPushOn, 
			notificationsSmsOn,
			updatedViaWebsiteAt
		}),
		signal: GLOBAL_FETCH_SIGNAL,
		retries: 0,
		retryDelay: 3000,
		retryOn: function (attempt, error, response) {
			return response?.data;
		}
	}).then((resp) => {
		if (!resp.ok && resp.status !== 302) {
			throw new Error('ERROR');
		}
		return resp.json();
	}).then((data) => {
		dispatch({
			type: ActionType.SET_SYSTEM_NOTIFICATIONS,
			success: true,
			updatedViaWebsiteAt: data.updatedAt,
			systemId: systemID,
			notificationsEmailOn,
			notificationsPushOn,
			notificationsSmsOn
		});
	})
	.catch((err) => {
		dispatch({
			type: ActionType.SET_SYSTEM_NOTIFICATIONS,
			success: false,
			systemId: systemID,
			notificationsEmailOn, 
			notificationsPushOn, 
			notificationsSmsOn
		});
	});
};

export const closeSettingSystemNotificationsNotification = () => (dispatch) => {
	return dispatch({ type: ActionType.CLOSE_SET_SYSTEM_NOTIFICATIONS_NOTIFICATION });
};
